<mat-toolbar class="mat-elevation-z8">
  {{ 'PRICING.ADDITIONAL_SERVICES.ADDITIONAL_SERVICES' | transloco }}
</mat-toolbar>

@if (isLoading) {
  <div class="spinner">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

<mat-dialog-content class="mt-3">
  <form [formGroup]="additionalServiceForm">

    <mat-card class="mb-3 pb-0">
      <mat-card-content>
        <mat-card-title class="mb-2">
          English
        </mat-card-title>

        <mat-form-field class="mb-2 w-100" appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput formControlName="nameEn" />
          @if (!additionalServiceForm.controls.nameEn.valid) {
            <mat-error>
              <!-- {{ 'PRICING.ADDITIONAL_SERVICES.NAME_REQUIRED' | transloco }} -->
              Name is required
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="mb-2 w-100" appearance="outline">
          <mat-label>Description</mat-label>
          <textarea matInput formControlName="descriptionEn"></textarea>
          @if (!additionalServiceForm.controls.descriptionEn.valid) {
            <mat-error>
              <!-- {{ 'PRICING.ADDITIONAL_SERVICES.DESCRIPTION_REQUIRED' | transloco }} -->
              Description is required
            </mat-error>
          }
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card class="mb-4 pb-0">
      <mat-card-content>
        <mat-card-title class="mb-2">
          Swedish
        </mat-card-title>

        <mat-form-field class="mb-2 w-100" appearance="outline">
          <mat-label>Namn</mat-label>
          <input matInput formControlName="nameSv" />
          @if (!additionalServiceForm.controls.nameSv.valid) {
            <mat-error>
              <!-- {{ 'PRICING.ADDITIONAL_SERVICES.NAME_REQUIRED' | transloco }} -->
              Namn är obligatoriskt
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="mb-2 w-100" appearance="outline">
          <mat-label>Beskrivning</mat-label>
          <textarea matInput formControlName="descriptionSv"></textarea>
          @if (!additionalServiceForm.controls.descriptionSv.valid) {
            <mat-error>
              <!-- {{ 'PRICING.ADDITIONAL_SERVICES.DESCRIPTION_REQUIRED' | transloco }} -->
              Beskrivning är obligatorisk
            </mat-error>
          }
        </mat-form-field>

      </mat-card-content>
    </mat-card>

    <mat-form-field class="mb-2 w-100" appearance="outline">
      <mat-label>{{ 'PRICING.ADDITIONAL_SERVICES.PRODUCT_CODE' | transloco }}</mat-label>
      <input matInput formControlName="productCode" />
      @if (!additionalServiceForm.controls.productCode.valid) {
        <mat-error>
          {{ 'PRICING.ADDITIONAL_SERVICES.PRODUCT_CODE_REQUIRED' | transloco }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="mb-2 w-100" appearance="outline">
      <mat-label>{{ 'PRICING.ADDITIONAL_SERVICES.AVAILABILITY' | transloco }}</mat-label>
      <input matInput type="number" formControlName="availability" />
      @if (!additionalServiceForm.controls.availability.valid) {
        <mat-error>
          {{ 'PRICING.ADDITIONAL_SERVICES.AVAILABILITY_REQUIRED' | transloco }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="mb-2 w-100" appearance="outline">
      <mat-label>{{ 'PRICING.ADDITIONAL_SERVICES.MINIMUM_STAY' | transloco }}</mat-label>
      <input matInput type="number" formControlName="minimumStay" />
      @if (!additionalServiceForm.controls.minimumStay.valid) {
        <mat-error>
          {{ 'PRICING.ADDITIONAL_SERVICES.MINIMUM_STAY_REQUIRED' | transloco }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="mb-2 w-100" appearance="outline">
      <mat-label>{{ 'PRICING.ADDITIONAL_SERVICES.STATUS' | transloco }}</mat-label>
      <mat-select formControlName="statusName">
        @for (status of statusOptions; track status) {
          <mat-option [value]="status.value">
            {{ status.name }}
          </mat-option>
        }
      </mat-select>
      @if (!additionalServiceForm.controls.statusName.valid) {
        <mat-error>
          {{ 'PRICING.ADDITIONAL_SERVICES.STATUS_REQUIRED' | transloco }}
        </mat-error>
      }
    </mat-form-field>

    <!-- <mat-form-field class="" appearance="outline">
    <mat-label>{{ 'PRICING.DISCOUNTCHECK.PARKING' | transloco }}</mat-label>
    <mat-select formControlName="parkingId">
      <mat-option value="">
        {{ 'PRICING.DISCOUNTCHECK.ALL_PARKINGS' | transloco }}
      </mat-option>
      <mat-option *ngFor="let parking of parkingVMs" [value]="parking.parkingId">
        {{ parking.parkingName }}
      </mat-option>
    </mat-select>
  </mat-form-field> -->

  <!-- <div class="mb-4 mx-2 w-100">
  <mat-label>{{ 'PRICING.ADDITIONAL_SERVICES.TYPE' | transloco }}</mat-label>
  <p>
    <mat-checkbox formControlName="mandatory">
      {{ 'PRICING.ADDITIONAL_SERVICES.MANDATORY' | transloco }}
    </mat-checkbox>
  </p>
  <input matInput hidden
    [value]="additionalServiceForm?.controls['mandatory'].value ? 'MandatoryForAllAdditionalServices' : 'None'"
    formControlName="typeName" />
</div> -->

<mat-form-field class="mb-2 w-100" appearance="outline">
  <mat-label>{{ 'PRICING.ADDITIONAL_SERVICES.PRICE' | transloco }}</mat-label>
  <input
    matInput
    [value]="additionalServiceForm.controls.totalPrice.value/(1 + (this.additionalServiceForm.controls.vatPercentage.value/100))"
    min="1"
    type="number"
    formControlName="price" />
  @if (!additionalServiceForm.controls.price.valid) {
    <mat-error>
      {{ 'PRICING.ADDITIONAL_SERVICES.PRICE_REQUIRED' | transloco }}
    </mat-error>
  }
</mat-form-field>

<!-- <mat-form-field class="mb-2 w-100" appearance="outline">
<mat-label>{{ 'PRICING.ADDITIONAL_SERVICES.VAT' | transloco }}</mat-label>
<input matInput type="number"
  [value]="additionalServiceForm.controls.price.value * (additionalServiceForm.controls.vatPercentage.value/100)"
  formControlName="vat" />
</mat-form-field> -->

<mat-form-field class="mb-2 w-100" appearance="outline">
  <mat-label>{{ 'PRICING.ADDITIONAL_SERVICES.VAT_PERCENT' | transloco }}</mat-label>
  <input matInput type="number" formControlName="vatPercentage" />
</mat-form-field>

<mat-form-field class="mb-2 w-100" appearance="outline">
  <mat-label>{{ 'PRICING.ADDITIONAL_SERVICES.TOTAL_PRICE' | transloco }}</mat-label>
  <input matInput type="number"
    formControlName="totalPrice" />
</mat-form-field>

<mat-form-field class="mb-2 w-100" appearance="outline">
  <mat-label>{{ 'PRICING.ADDITIONAL_SERVICES.PERFORMING_ORGANIZATION_NAME' | transloco }}</mat-label>
  <mat-select formControlName="performingOrganization">
    @for (org of availableSubServiceOrgs; track org) {
      <mat-option [value]="org">
        {{ org.label }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field class="mb-2 w-100" appearance="outline">
  <mat-label>{{ 'PRICING.ADDITIONAL_SERVICES.PERFORMING_ORGANIZATION_NAME' | transloco }}</mat-label>
  <input matInput formControlName="performingOrganizationName" />
</mat-form-field>

@if (data.edit) {
  <mat-form-field class="mb-2 w-100" appearance="outline">
    <mat-label>Id</mat-label>
    <input matInput formControlName="id" />
  </mat-form-field>
}

@if (data.edit) {
  <mat-form-field class="mb-2 w-100" appearance="outline">
    <mat-label>{{ 'PRICING.ADDITIONAL_SERVICES.PRODUCT_ID' | transloco }}</mat-label>
    <input matInput formControlName="productId" />
  </mat-form-field>
}
</form>

</mat-dialog-content>

<mat-dialog-actions class="py-4 pe-4" align="end">
  <button mat-raised-button color="primary" [disabled]="additionalServiceForm.invalid || isLoading"
    (click)="submitForm()">
    @if (!data.edit) {
      <span>
        {{ 'PRICING.FORM.CREATE' | transloco }}
      </span>
    }
    @if (data.edit) {
      <span>
        {{ 'PRICING.FORM.EDIT' | transloco }}
      </span>
    }
  </button>
  <button mat-button mat-dialog-close [disabled]="isLoading">
    {{ 'PRICING.FORM.CANCEL' | transloco }}
  </button>
</mat-dialog-actions>
